/**
 * User-visible job type labels.
 * SQL `jobs.kind` CHECK values stay frozen. Bare `mind_check` is not dispatched.
 */

/** Type column / command palette. Does not say this row is a gate. */
export const MIND_CHECK_JOB_LABEL = "mind_check (ignored)";

/** Shared denial. Keep "not" on the same line as each gate phrase. */
export const NOT_A_BOARD_GATE =
  "not rsci mind check, not a Think DESIGN gate, not a board gate";

/** Sheet, API 400, and complete refusal. SQL value is not renamed. */
export const MIND_CHECK_JOB_NOTE =
  `SQL jobs.kind=mind_check stays in the frozen CHECK. This stack does not run it — ${NOT_A_BOARD_GATE}.`;

/** Findings empty-state / review copy. Not the Sandbox mind_check tool. */
export const AGENT_FINDINGS_NOT_A_GATE =
  `agent_findings is the circuit_diff summary on DesignReview — ${NOT_A_BOARD_GATE}.`;

export function isSqlMindCheckKind(kind: string): boolean {
  return kind === "mind_check";
}

/** SQL leftovers and non-drainable scene rows — not a JobsChecks run. */
export function isNonDeterministicJobKind(kind: string, kindDetail?: string | null): boolean {
  if (isSqlMindCheckKind(kind)) return true;
  if (kind === "bom") return true;
  const detail = kindDetail?.trim() || "";
  if (kind === "scene") return detail !== "circuit_diff" && detail !== "agent_findings";
  if (kind === "import_kicad" || kind === "git_commit") return Boolean(detail);
  return true;
}

/** Display label. Dispatch keys stay on `jobType` (`kind_detail` or SQL kind). */
export function jobTypeLabel(kind: string, kindDetail?: string | null): string {
  if (isSqlMindCheckKind(kind)) return MIND_CHECK_JOB_LABEL;
  const detail = kindDetail?.trim();
  return detail || kind;
}
